import { RegisterRole } from '../../../store/auth/enum/register-role';

export const REGISTER_ROLES = [
  {
    key: RegisterRole.PATIENT,
    title: 'patient',
    description: 'patient.description',
    image: {
      src: '/public-assets/img/patient.webp',
      type: 'image/webp',
    },
  },
  {
    key: RegisterRole.DOCTOR,
    title: 'doctor',
    description: 'doctor.description',
    image: {
      src: '/public-assets/img/doctor.webp',
      type: 'image/webp',
    },
  },
  {
    key: RegisterRole.FAMILY_DOCTOR,
    title: 'familyDoctor',
    description: 'familyDoctor.description',
    image: {
      src: '/public-assets/img/familyDoctor.webp',
      type: 'image/webp',
    },
  },
];
